import { Text } from 'components/ui/text';
import { rem } from 'polished';
import styled from 'styled-components';

export const ReminderListStyled = styled.ul`
  margin: 0;
  padding: 0;
`;

export const ReminderListItem = styled.li`
  list-style: none;

  & + & {
    margin-top: ${rem(16)};
  }

  :last-of-type {
    margin-bottom: ${rem(32)};
    padding-bottom: ${rem(32)};
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  }
`;

export const Wrapper = styled.div`
  margin-top: 0;
`;

export const ReminderHeadingWrapper = styled.div`
  margin-top: ${rem(16)};
`;

export const BottomBorderText = styled(Text)`
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
`;
